import { render, staticRenderFns } from "./QueuePCR.vue?vue&type=template&id=28937959"
import script from "./QueuePCR.vue?vue&type=script&lang=js"
export * from "./QueuePCR.vue?vue&type=script&lang=js"
import style0 from "./QueuePCR.vue?vue&type=style&index=0&id=28937959&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports